import renderApp from 'components/App'
import reportWebVitals from './reportWebVitals'

renderApp()
reportWebVitals()
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
